import { WithId } from 'django-rest-react'
import { displayDisplayable } from '../utils';
import { CATEGORIAEVENTO_EVENTO_TIPOLOGIE } from './auto-enums';

export interface Displayable extends WithId {
  display: string
}

export {
  PROBLEMA_FONTE as FONTE,
  VERSIONESHORTLIST_STATO_SHORTLIST as STATO_SHORTLIST,
  FLAGSMISTATORE_FLAGS as FLAGS_SMISTATORE,
  PARTECIPANTE_PERMESSI as PERMESSI,
} from './auto-enums';


export const COMPETENZA_COLORS = {
  gen: "concrete",
  mate: "danger",
  fis: "emerald",
  mec: "wet-asphalt",
  term: "pomegranate",
  em: "electric-yellow",
  ottica: "concrete",
}

export const displayTipologiaEvento = (obj: string) => displayDisplayable(obj, CATEGORIAEVENTO_EVENTO_TIPOLOGIE)
